import { palette as globalPalette } from 'main/ui'
import * as React from 'react'

export const stars = (count: number) => {
  if (count < 1) {
    return ''
  }

  return (
    <span
      style={{ color: globalPalette.goldenrod2 }}
      dangerouslySetInnerHTML={{ __html: '&#9733;'.repeat(count) }}
    />
  )
}
